module.exports = __webpack_public_path__ + "img/modal1.2cfdbb53.jpg";